@let asset = this.asset$ | async;
@let groups = this.groups$ | async;
@let activeTab = this.activeTab$ | async;
@let showPhotos = this.showPhotos$ | async;
@let hasAnalysis = this.hasAnalysis$ | async;

@if (asset !== null && groups !== null && activeTab !== null && showPhotos !== null && hasAnalysis !== null) {
    <loren-asset-details-base-information
            [asset]="asset"
            [groups]="groups"
            [properties]="properties()"
            [assetType]="assetType()"
            [isHandset]="isHandset"
            [location]="location()" />

    @if (asset.location) {
        <loren-asset-details-map [asset]="asset" />
    }

    <mat-tab-group
            class="loren-asset-details-tabs"
            mat-align-tabs="start"
            mat-stretch-tabs="false"
            [preserveContent]="true"
            [selectedIndex]="activeTab"
            (selectedTabChange)="tabChangeHandler($event)">
        <mat-tab [label]="tabLabels[0].label | transloco">
            <loren-page-content [flush]="!isHandset" [unrounded]="!isHandset">
                <loren-loren-asset-details-info-table [asset]="asset" />
                @if (hasAnalysis) {
                    <loren-loren-asset-details-analysis [asset]="asset"/>
                }
            </loren-page-content>
        </mat-tab>
        <mat-tab [label]="tabLabels[1].label | transloco">
            <loren-page-content [flush]="!isHandset">
                @if (activeTab === 1) {
                                        <loren-loren-asset-details-charts
                                                        [asset]="asset"
                                                        [isHandset]="isHandset" />
                }
            </loren-page-content>
        </mat-tab>
                <mat-tab [label]="tabLabels[2].label | transloco">
                    <loren-page-content [flush]="!isHandset">
                        <loren-asset-details-alarms-table [asset]="asset" />
                    </loren-page-content>
                </mat-tab>
                @if (showPhotos) {
                    <mat-tab [label]="tabLabels[3].label | transloco">
                        <loren-page-content [flush]="!isHandset">
                            <loren-asset-details-photos [asset]="asset" [isHandset]="isHandset" />
                        </loren-page-content>
                    </mat-tab>
                }
    </mat-tab-group>
} @else {
    <loren-page-content>
        <mat-spinner />
    </loren-page-content>
}
